// removed by extract-text-webpack-plugin
module.exports = {"PlaceholderDefaultColor":"#d8d8d8","PlaceholderDarkGrey":"#8e8e8e","Tile":"Tile-45t6xubdqn8mp4r1srxmadppn8h4ykg3nyf7by4xpdnca83rxwg62gyppyux3wrratc4z2bmu99xssyy8vqs8sngn2m7p7hdz6ze1re","Overlay":"Overlay-2kfzdgkyechj11kpkhtwzshnrntxyhqr4rvqana6vgba6u6ubxzckug9ecxpxvvfyw75stbk2k8fdtg5wygswwktba9xa6b5j6yj6az","loading":"loading-3h5nubp3323bxgy38v6rm39xg4613gk7kce52c9ubmrrh59jyacmuhbyad8p5us86qv8gw6y9382xpy3uaefvwykv8brsywe7c9rp6v","pulse":"pulse-3fjdc4dux2ycjaqefzac7qb3p6sznxs7nmk8ztn2xkhwnzpnxkwpwjpur23fqqx5cjez9jbuh7n6fxny1w2x98h6uru26cwmufkfuwd"};


//////////////////
// WEBPACK FOOTER
// ./src/views/CSR/components/GroupTile/GroupTile.module.scss
// module id = 1619
// module chunks = 0